import React, { useState } from "react";
import eng from "../../assets/circle-flag-of-usa-free-png.webp";
import arbic from "../../assets/saudi-arabia-flag-png-large.png";
import english from "../../assets/eng.png";

function LanguageDropdown() {
  const [showDropdown, setShowDropDown] = useState(false);
  return (
    <span className="relative">
      <button onClick={() => setShowDropDown(!showDropdown)}>
        <div className="mt-2 ">
          <img src={eng} alt="" height="0" width="30" />
        </div>
      </button>
      <div
        className={
          (showDropdown ? "block " : "hidden ") +
          "absolute top-11 left-4 -translate-x-[90%] bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-32"
        }
      >
        <button
          className=" text-sm py-2 text-[#7B20C7] px-3 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          onClick={(e) => e.preventDefault()}
        >
          <div path="/" className="flex gap-2 ">
            <img src={arbic} alt="" height="10" width="30" />
            <span className="font-semibold">Arabic</span>
          </div>
        </button>
        <button
          className=" text-sm py-2 text-[#7B20C7] px-3 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          onClick={(e) => e.preventDefault()}
        >
          <div className="flex gap-2 ">
            <img src={english} alt="" height="10" width="30" />
            <span className="font-semibold">English</span>
          </div>
        </button>
      </div>
    </span>
  );
}

export default LanguageDropdown;
